<template>
  <LoginWrapper :leftArea="false">
    <!-- form -->
    <div class="login-content">
      <h3>
        {{ $t('attach_share_title') }}
      </h3>
      <div class="login-form">
        <!-- 内容显示：有数据则，没过期才显示 -->
        <div class="login-form-item" v-if="shareInfo && available">
          <a-form-item :label="$t('attach_share_name')" style="margin-bottom: 0;">
            {{ shareInfo.name }}
          </a-form-item>

          <a-form-item :label="$t('attach_form_path')" style="margin-bottom: 0;">
            {{ shareInfo.url }}
          </a-form-item>

          <a-form-item
            :label="$t('attach_form_file_desc')"
            v-if="shareInfo.intro"
            style="margin-bottom: 0;"
          >
            {{ shareInfo.intro }}
          </a-form-item>

          <a-form-item :label="$t('attach_share_size')" style="margin-bottom: 0;">
            {{ shareInfo.size | formatSize }}
          </a-form-item>
        </div>
        <!-- 提取码：无数据就一直显示 -->
        <a-form :form="form" v-if="!shareInfo">
          <a-form-item :label="$t('attach_share_access_code')" prop="shareCode">
            <a-input
              :placeholder="$t('attach_share_access_code_placeholder')"
              v-decorator="[
                'code',
                {
                  rules: [
                    {
                      required: true,
                      message: this.$t('attach_share_access_code_placeholder'),
                    },
                  ],
                },
              ]"
              v-model="shareCode"
              ref="code"
            >
              <Icon type="user" slot="prefix" />
            </a-input>
          </a-form-item>
        </a-form>

        <div class="share-btn">
          <div class="login-error" v-if="error">
            {{ error }}
          </div>
          <div>
            <!-- 下载：有数据，可见才能下载 -->
            <a-button
              type="primary"
              @click="download"
              :loading="loading"
              v-if="shareInfo && available"
            >
              {{ $t('com_btn_download') }}
            </a-button>

            <!-- 获取文件：无数据就一直显示 -->
            <a-button
              type="primary"
              @click="getShareFile"
              :loading="loading"
              ref="loginBtn"
              v-if="!shareInfo"
            >
              {{ $t('com_btn_get_share_file') }}
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </LoginWrapper>
</template>
<script>
import LoginWrapper from '@/components/Layout/Login.vue';
import { shareDocument } from '@/api/attach';
import { downloadFile } from '@/config/oss';

export default {
  components: {
    LoginWrapper,
  },
  data() {
    return {
      filters: this.$options.filters,
      loading: false,
      shareInfo: null,
      shareCode: '',

      form: this.$form.createForm(this, { name: 'shareForm' }),
      error: '',
      available: null,
    };
  },
  created() {
    // this.getShareFile();
  },

  methods: {
    // 输入事件
    input() {
      this.error = '';
    },

    // 获取分享文件
    getShareFile() {
      if (!this.shareCode) {
        this.error = this.$t('attach_share_access_code_placeholder');
        return;
      }
      const params = {
        rc: this.$route.query.rc,
        tt: this.$route.query.tt,
        pc: this.shareCode,
      };
      this.loading = true;
      shareDocument(params)
        .then(res => {
          if (res.code === 0) {
            // 是否过期
            this.available = res.data.available;

            // 有数据且未过期
            if (res.data && res.data.available) {
              this.shareInfo = res.data;
            } else {
              this.shareInfo = null;
              this.error = res.message || this.$t('attach_share_expired');
            }
          } else {
            this.error = res.message;
            this.available = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分享的下载
    async download() {
      if (this.loading) return;

      this.loading = true;
      await downloadFile(this.shareInfo.url, 3600, false);

      // 下载成功后，清空数据
      // 5s后再次获取分享文件
      setTimeout(() => {
        this.loading = false;
      }, 5000);
    },
  },
};
</script>

<style lang="less" scoped>
.login-content {
  width: 700px;
  padding: 24px;

  h3 {
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
  }

  .login-logo {
    text-align: center;
    padding: 58px 0 5px 0;
    svg {
      margin-bottom: 20px;
      width: 240.8px;
      height: 106.4px;
    }
  }

  .login-title {
    font-size: 20px;
    color: #333;
  }

  .login-language {
    width: 120px;
    ::v-deep .ant-select-selection {
      border: none;
      box-shadow: 0 0 10px rgba(118, 118, 118, 0.2);
    }
  }

  .share-btn {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    align-items: center;

    > div {
      display: flex;
      gap: 16px;
      align-items: center;
    }

    .login-error {
      margin: 15px 0 10px 0;
      line-height: 20px;
      color: #f5222d;
      font-size: 12px;
    }
  }
}

.login-copyright {
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
</style>
